module.exports = __webpack_public_path__ + "img/京东.2a22b045.png";